import Vue from "@/init";

const uri = "article{/id}";

var customActions = {
  preview: { method: "GET", url: uri + "/preview" }
};

const ArticleResource = Vue.resource(uri, {}, customActions);

export default ArticleResource;
